module.exports = __webpack_public_path__ + "static/media/rw.7fe5146b.svg";